import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { btLightBlueColor } from '../../../assets/jss/nextjs-material-kit-pro';

const QuestionnaireInfo = ({ className }) => (
  <Grid container direction="column" className={className} style={{ textAlign: 'left', width: '76%' }} spacing={2}>
    <Grid item xs={12}>
      <Typography
        variant="h6"
        style={{
          color: btLightBlueColor,
          fontWeight: 600,
          marginBottom: 8,
          textAlign: 'left',
          width: '100%',
        }}
      >
        Questionnaire
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="body1" paragraph>
        Please review each statement carefully and indicate how strongly you agree or disagree based on your experience with the applicant. Use the
        following scale:
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="body1" paragraph align="center">
        <strong>Strongly Disagree – Disagree – Neutral – Agree – Strongly Agree – NA</strong>
      </Typography>
    </Grid>
    <Grid item xs={12}>
      <Typography variant="body1" paragraph>
        <strong>NA = Not Applicable</strong>. The statement does not apply to your relationship or experience with the applicant.
      </Typography>
    </Grid>
  </Grid>
);

export default QuestionnaireInfo;
